export default __webpack_public_path__ + "static/media/provider-status.7dd4a3fa.svg";